import React from "react";

const FooterButton = ({ child1, child2 }) => {
  return (
    <footer className="d-flex flex-wrap-reverse justify-content-between align-items-center bg_primary py-3 px-3 md:h-69">
      {child1}
      {child2}
    </footer>
  );
};

export default FooterButton;
